import ImageDetailModelEditor from "./models/ImageDetailModelEditor.js";
import ImageColumnModelEditor from "./models/ImageColumnModelEditor.js";
import ImageEditor from "./ImageEditor.js";
import ImageDetailModel from "./models/ImageDetailModel.js";
import ImageColumnModel from "./models/ImageColumnModel.js";
import ImageDetailRenderer from "./ImageDetailRenderer.js";
import ImageColumnRenderer from "./ImageColumnRenderer.js";
function install(molten) {
  molten.addPlugin('Model', {
    type: ImageDetailModel.TYPE,
    model: ImageDetailModel
  });
  molten.addPlugin('ModelEditor', {
    type: ImageDetailModel.TYPE,
    editor: ImageDetailModelEditor
  });
  molten.addPlugin('DetailRenderer', {
    type: ImageDetailModel.TYPE,
    renderer: ImageDetailRenderer
  }); // eslint-disable-line

  molten.addPlugin('Model', {
    type: ImageColumnModel.TYPE,
    model: ImageColumnModel
  });
  molten.addPlugin('ModelEditor', {
    type: ImageColumnModel.TYPE,
    editor: ImageColumnModelEditor
  });
  molten.addPlugin('ColumnRenderer', {
    type: ImageColumnModel.TYPE,
    renderer: ImageColumnRenderer
  }); // eslint-disable-line

  molten.addPlugin('AttributeValueEditor', ImageEditor);
}
export default {
  install
};